import { Navigate } from "react-router-dom";
import { getCookies } from "@/utility/helper";
import { RoutesLink } from "@/utility/RouteLinks";

interface PublicRouteProps {
  element: React.ReactNode;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ element }) => {
  const business = import.meta.env.VITE_BUSINESS;
  const token = getCookies(business + "token");

  if (token) {
    return <Navigate to={RoutesLink.dashboard} replace />;
  }

  return <>{element}</>;
};

export default PublicRoute;